/**
 * Captures the browser's beforeinstallprompt event so the INSTALL GAME button can fire it later.
 * Silently degrades on browsers without PWA install support (Firefox, iOS Safari on some versions).
 */
type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
};

export class InstallPromptHelper {
  private captured: BeforeInstallPromptEvent | null = null;
  private handler = (e: Event): void => {
    e.preventDefault();
    this.captured = e as BeforeInstallPromptEvent;
  };

  watch(): void {
    window.addEventListener("beforeinstallprompt", this.handler);
  }

  unwatch(): void {
    window.removeEventListener("beforeinstallprompt", this.handler);
  }

  isAvailable(): boolean {
    return this.captured !== null;
  }

  async prompt(): Promise<"accepted" | "dismissed" | "unavailable"> {
    if (!this.captured) return "unavailable";
    await this.captured.prompt();
    const choice = await this.captured.userChoice;
    this.captured = null;
    return choice.outcome;
  }
}
